export default "__VITE_ASSET__3b16b5f0__"